import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IState } from '../../redux/store';
import * as CreditsActions from '../../redux/credits/credits.actions';

interface IStaticDataInitializerState {
  isInitialized: boolean;
}

const mapStateToProps = (state: IState) => ({
  staticServices: state.credits.staticServices,
});

const mapDispatchToProps = {
  loadStaticCsvServicesData: CreditsActions.loadStaticCsvServicesData,
  loadStaticXlsxServicesData: CreditsActions.loadStaticXlsxServicesData,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type IReduxProps = ConnectedProps<typeof connector>;

class StaticDataInitializer extends React.Component<IReduxProps, IStaticDataInitializerState> {

  constructor(props: IReduxProps) {
    super(props);
    this.state = {
      isInitialized: false,
    };
  }

  componentDidMount() {
    if (!this.state.isInitialized && this.props.staticServices.length === 0) {
      this.props.loadStaticXlsxServicesData();
      this.setState({ isInitialized: true });
    }
  }

  render() {
    return null;
  }
}

export default connector(StaticDataInitializer); 